import { create } from "@/modules/core/store"
import type { ProgramType } from "@/modules/programs/types/programTypes"

type WeekToCopy =
  | {
      programType: ProgramType.VIRTUAL
      originProgramId: string
      originProgramName: string
      originStartDate: string
      originEndDate: string
    }
  | {
      programType: ProgramType.ONOFF
      originProgramId: string
      originProgramName: string
      originStartIndex: number
      originEndIndex: number
    }
  | {
      programType: ProgramType.PRO
      originProgramId: string
      originProgramName: string
      originStartDate: string
      originEndDate: string
    }

type SessionWeekCopyActions = {
  setWeekToCopy: (weekToCopy: WeekToCopy) => void
  clearWeekToCopy: () => void
}

type SessionWeekCopyState = {
  weekToCopy: WeekToCopy | null
  actions: SessionWeekCopyActions
}

const useSessionWeekCopyStore = create<SessionWeekCopyState>()((set) => ({
  weekToCopy: null,
  actions: {
    setWeekToCopy: (weekToCopy: WeekToCopy) => set({ weekToCopy }),
    clearWeekToCopy: () => set({ weekToCopy: null }),
  },
}))

export const useSessionWeekCopy = () => useSessionWeekCopyStore((state) => state.weekToCopy)
export const useSessionWeekCopyActions = () => useSessionWeekCopyStore((state) => state.actions)
